import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";
import { useWaiterWorkSession } from "@/hooks/useWaiterWorkSession";

export function SessionStatusBadge() {
  const { hasActiveSession, remainingMinutes } = useWaiterWorkSession();

  if (!hasActiveSession || remainingMinutes === null) {
    return null;
  }

  const hours = Math.floor(remainingMinutes / 60);
  const mins = remainingMinutes % 60;

  const formatTime = () => {
    if (hours > 0) {
      return `${hours}h${mins > 0 ? ` ${mins}min` : ""} restantes`;
    }
    return `${mins}min restantes`;
  };

  const isLowTime = remainingMinutes < 60;

  return (
    <Badge
      variant={isLowTime ? "destructive" : "secondary"}
      className="flex items-center gap-1"
    >
      <span className="relative flex h-2 w-2">
        <span
          className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
            isLowTime ? "bg-red-400" : "bg-green-400"
          }`}
        ></span>
        <span
          className={`relative inline-flex rounded-full h-2 w-2 ${
            isLowTime ? "bg-red-500" : "bg-green-500"
          }`}
        ></span>
      </span>
      <Clock className="h-3 w-3" />
      <span className="text-xs">{formatTime()}</span>
    </Badge>
  );
}
